import ApiGateway from 'theme/api/api-gateway'
import { useFirebaseService } from 'theme/services/firebase-service'
import { useEffect, useState } from 'react'
import { useAuthService } from 'theme/services/auth/auth-service'
import { off } from 'firebase/database'

export const useUserSessions = (conferenceId) => {
  const [userRegistrations, setUserRegistrations] = useState({
    all: [],
    workshop: {
      registered: [],
      approved: [],
    },
  })
  const firebase = useFirebaseService()
  const authService = useAuthService()
  const user = authService?.user

  const checkIsRegistered = (sessionId) => {
    return userRegistrations.workshop.registered.find((item) => item.sessionId === sessionId)
  }

  const checkIsApproved = (sessionId) => {
    return userRegistrations.workshop.approved.find((item) => item.sessionId === sessionId)
  }

  useEffect(() => {
    if (!user) {
      return
    }

    const handleRegistrations = (registrations) => {
      if (!registrations) {
        return
      }

      const workshopRegistrations = registrations.filter((item) => item.sessionType === 'Workshop')

      const registeredWorkshops = workshopRegistrations.filter(
        (item) => item.registration?.status.toLowerCase() === 'registered',
      )
      const approvedWorkshops = workshopRegistrations.filter(
        (item) => item.registration?.status.toLowerCase() === 'approved',
      )

      setUserRegistrations({
        all: registrations,
        workshop: {
          registered: registeredWorkshops,
          approved: approvedWorkshops,
        },
      })
    }

    const workshopsDbRef = ApiGateway.observeUserRegistrations(
      firebase,
      user.uid,
      conferenceId,
      handleRegistrations,
    )

    return () => {
      if (workshopsDbRef) {
        off(workshopsDbRef)
      }
    }
  }, [user])

  return {
    userUsedPlaces: userRegistrations.workshop.registered.length,
    checkIsRegistered,
    checkIsApproved,
    registrations: userRegistrations.all,
  }
}
